module.exports = __webpack_public_path__ + "img/hultza_no.05ff4109.png";